import { Badge } from '@atom/badge/badge';
import { IntegrationStateEnum } from '@enum/integration-state.enum';
import { ConnectionInterface, ConnectionStateEnum } from '@interface/connection/connection.interface';
import { IntegrationInterface } from '@interface/integration/integration.interface';
import { isExist } from '@util/data/is-exist';

interface BadgeProps {
  connection: ConnectionInterface;
  integration: IntegrationInterface;
}

export const IntegrationBadge = ({ integration, connection }: BadgeProps) => {
  if (!isExist(integration) || integration.state === IntegrationStateEnum.DISABLED) {
    return <Badge status='error' text='Disabled' />;
  }

  if (integration.state === IntegrationStateEnum.NEEDS_CONFIGURATION) {
    return <Badge status='warning' text='Need configuration' />;
  }

  if (connection.state === ConnectionStateEnum.INVALID) {
    return <Badge status='error' text='Invalid' />;
  }

  if (connection.state === ConnectionStateEnum.Available) {
    return <Badge status='processing' text='Available' />;
  }

  if (connection.state === ConnectionStateEnum.Authorized) {
    return <Badge status='processing' text='Authorized' />;
  }

  if (connection.state === ConnectionStateEnum.Added) {
    return <Badge status='processing' text='Need configuration' />;
  }

  return <Badge status='success' text='Success' />;
};
